/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{strict as n}from"../../core/jsonMap.js";const o=n()({AIX:"aix",EPS:"eps",GIF:"gif",JPG:"jpg",PDF:"pdf",PNG32:"png32",PNG8:"png8",SVG:"svg",SVGZ:"svgz",TIFF:"tiff"},{ignoreUnknown:!1});export{o as formatJsonMap};
